import { Link, ResponsiveImage } from "@quintype/components";
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { getTextColor } from "../../../utils/utils";
import { useStateValue } from "../../SharedContext";

import "./author.m.css";

const AuthorBase = ({ story, hideAuthorImage, isBottom, prefix = "", config = {}, showMultipleAuthor }) => {
  const configData = useStateValue() || {};
  const isAuthor = get(configData, ["showAuthor"], true);
  const getMultipleAuthors = (authors) => {
    return authors?.map(({ id, name, slug }, index) => (
      <Link href={`/author/${slug}`} key={`${id}-${index}`} aria-label="author-name" disableAjaxLinks={true}>
        {name}
      </Link>
    ));
  };
  const {
    "avatar-url": avatarUrl,
    "avatar-s3-key": avatarS3Key,
    name: authorName,
    slug,
  } = get(story, ["authors", 0], "");

  const isBottomClasses = isBottom ? "bottom-fix" : "";
  const textColor = getTextColor(configData.theme);
  const mountAt = get(config, ["mountAt"], "");

  const authorImage = (dir) => {
    if (!avatarUrl && !avatarS3Key) {
      return null;
    }
    return (
      <div styleName={`author-image ${dir}-image`} data-test-id="author-image">
        <figure>
          {avatarS3Key ? (
            <ResponsiveImage
              slug={avatarS3Key}
              aspect-ratio={[1, 1]}
              defaultWidth={400}
              imgParams={{ auto: ["format", "compress"], q: 70 }}
              alt={authorName}
              shouldDecodeImage={true}
            />
          ) : (
            <img src={`${avatarUrl}?q=70`} />
          )}
        </figure>
      </div>
    );
  };
  const isPrefix = (dir) => {
    if (prefix) {
      return (
        <div className="arr-author-prefix" styleName={`prefix ${textColor}`}>
          {prefix}
        </div>
      );
    }
    return !hideAuthorImage && authorImage(dir);
  };
  return (
    <span>
      {isAuthor && (
        <span
          className="author-name arr-author-name arrow-component"
          styleName={`author ${isBottomClasses}`}
          aria-label="author-name"
        >
          {isPrefix("ltr")}
          <div className="author-name" styleName={`author-name ${textColor}`} data-test-id="author-name">
            {showMultipleAuthor ? (
              getMultipleAuthors(story?.authors)
            ) : (
              <Link href={`${mountAt}/author/` + slug} disableAjaxLinks={true}>
                {authorName || story["author-name"]}
              </Link>
            )}
          </div>
          {!prefix && isPrefix("rtl")}
        </span>
      )}
    </span>
  );
};

function mapStateToProps(state) {
  return {
    config: get(state, ["qt", "config"], {}),
  };
}

export const Author = connect(mapStateToProps)(AuthorBase);

AuthorBase.propTypes = {
  /** The Story Object from the API response */
  story: PropTypes.object.isRequired,
  /** Hide Author Avatar Image */
  hideAuthorImage: PropTypes.bool,
  // fix Author bottom of the storyCard
  isBottom: PropTypes.bool,
  // fix prefix before the author name
  prefix: PropTypes.string,
  config: PropTypes.object,
  showMultipleAuthor: PropTypes.bool,
};

AuthorBase.defaultProps = {
  hideAuthorImage: false,
  isBottom: false,
  prefix: "",
  showMultipleAuthor: true,
};
